(function ($) {

    /*
     * делаем проверку на 'drupal'
     * если ='underfined' то выполняем функцию init() после выполнения ajax
     * если !='underfined' то просто выполняем функцию init() при загрузке страницы
     * свой код пишем внутри init()
    */
    if (typeof Drupal !== "undefined") {
        Drupal.behaviors.customDrupalWebform = {
            attach: function (context, settings) {
                init();
            }
        };
    } else {
        init();
    }

    function init() {

        // запрещаем в текстовом поле с телефоном вводить буквенные символы
        $("input[type='tel']").keypress(function (event) {
            var key, keyChar;
            if (!event) var event = window.event;
            if (event.keyCode) key = event.keyCode;
            else if (event.which) key = event.which;
            /*
              если нажата одна из следующих клавиш: скобки, плюс, минус, пробел, enter, tab, backspace, del, стрекла влево, стрелка вправо
              тогда на этом завершаем работу функции, т..к эти клавиши нужны для нормальной работы с полями форм
            */
            if (key == null || key == 40 || key == 41 || key == 43 || key == 45 || key == 32 || key == 0 || key == 8 || key == 13 || key == 37 || key == 39 || key == 46 || key == 9) return true;
            keyChar = String.fromCharCode(key);
            /*
              d - это зарезервированное сокращение в регулярных выражениях, означает любая цифра
            */
            if (!/\d/.test(keyChar)) return false;
        });

        $("label").on('click', function() {
            $(this).addClass("focus");
            $(this).next().focus();
        });

        const input = $(".form-item textarea, .form-item input");
        input.each(function () {
            if ($(this).val() !== "") {
                $(this).parents(".form-item").find("label").addClass("focus");
            }
            if ($(this).hasClass("error")) {
                $(this).parents(".form-item").find("label").addClass("error");
            }
        });
        input.on("focus", function() {
            $(this).parents(".form-item").find("label").addClass("focus");
        });
        input.on("blur", function () {
            let thisInput = $(this);
            thisInput.parents(".form-item").find("label").removeClass("focus");
            if (thisInput.val() !== "") {
                thisInput.parents(".form-item").find("label").addClass("focus");
            }
            setTimeout(function () {
                console.log(thisInput.hasClass("error"));
                if (thisInput.hasClass("error")) {
                    thisInput.parents(".form-item").find("label").addClass("error");
                }
            }, 100);
        });

        $("input[type='tel']").ready(function () {
            if ( $("input[type='tel']").length > 0 ) {
                $("input[type='tel']").intlTelInput({
                    initialCountry: "us",
                    separateDialCode: true,
                    autoPlaceholder: "polite",
                    // utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.5/js/utils.js",
                });
            }
        });

    }

    // // задаем левый отступ у поля с телефоном
    // // т.к. при открытии модалки почему-то левый отступ у поля телефона в 1200px? т.е. расчитывается не правильно
    // $.widget("ui.dialog", $.ui.dialog, {
    //     open: function() {
    //         $(".ui-dialog .iti__flag-container").each(function () {
    //             let iti = $(this);
    //             $(iti[0]).ready(function () {
    //                 iti[0].parentElement.querySelector("input").style.paddingLeft = iti[0].clientWidth + "px";
    //             });
    //         });
    //         return this._super();
    //     }
    // });

})(jQuery);